"use client";

import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["defaultIndex", "vertical", "manual", "onChange", "selectedIndex"],
  _excluded2 = ["id", "disabled", "autoFocus"],
  _excluded3 = ["id", "tabIndex"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useFocusRing as te } from "@react-aria/focus";
import { useHover as de } from "@react-aria/interactions";
import G, { createContext as re, useContext as ne, useMemo as D, useReducer as ce, useRef as q } from "react";
import { useActivePress as fe } from '../../hooks/use-active-press.js';
import { useEvent as S } from '../../hooks/use-event.js';
import { useId as ae } from '../../hooks/use-id.js';
import { useIsoMorphicEffect as W } from '../../hooks/use-iso-morphic-effect.js';
import { useLatestValue as j } from '../../hooks/use-latest-value.js';
import { useResolveButtonType as be } from '../../hooks/use-resolve-button-type.js';
import { useSyncRefs as U } from '../../hooks/use-sync-refs.js';
import { FocusSentinel as me } from '../../internal/focus-sentinel.js';
import { Hidden as Pe } from '../../internal/hidden.js';
import { Focus as P, FocusResult as K, focusIn as v, sortByDomNode as H } from '../../utils/focus-management.js';
import { match as w } from '../../utils/match.js';
import { microTask as ye } from '../../utils/micro-task.js';
import { getOwnerDocument as xe } from '../../utils/owner.js';
import { RenderFeatures as oe, forwardRefWithAs as O, mergeProps as le, render as N } from '../../utils/render.js';
import { StableCollection as ge, useStableCollectionIndex as se } from '../../utils/stable-collection.js';
import { Keys as y } from '../keyboard.js';
var Ae = function (t) {
    return t[t.Forwards = 0] = "Forwards", t[t.Backwards = 1] = "Backwards", t;
  }(Ae || {}),
  Ee = function (o) {
    return o[o.Less = -1] = "Less", o[o.Equal = 0] = "Equal", o[o.Greater = 1] = "Greater", o;
  }(Ee || {}),
  Re = function (n) {
    return n[n.SetSelectedIndex = 0] = "SetSelectedIndex", n[n.RegisterTab = 1] = "RegisterTab", n[n.UnregisterTab = 2] = "UnregisterTab", n[n.RegisterPanel = 3] = "RegisterPanel", n[n.UnregisterPanel = 4] = "UnregisterPanel", n;
  }(Re || {});
var Le = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, 0, function _(e, r) {
    var c;
    var t = H(e.tabs, function (T) {
        return T.current;
      }),
      o = H(e.panels, function (T) {
        return T.current;
      }),
      a = t.filter(function (T) {
        var d;
        return !((d = T.current) != null && d.hasAttribute("disabled"));
      }),
      n = _objectSpread(_objectSpread({}, e), {}, {
        tabs: t,
        panels: o
      });
    if (r.index < 0 || r.index > t.length - 1) {
      var T = w(Math.sign(r.index - e.selectedIndex), _defineProperty(_defineProperty(_defineProperty({}, -1, function () {
        return 1;
      }), 0, function _() {
        return w(Math.sign(r.index), _defineProperty(_defineProperty(_defineProperty({}, -1, function () {
          return 0;
        }), 0, function _() {
          return 0;
        }), 1, function _() {
          return 1;
        }));
      }), 1, function _() {
        return 0;
      }));
      if (a.length === 0) return n;
      var d = w(T, _defineProperty(_defineProperty({}, 0, function _() {
        return t.indexOf(a[0]);
      }), 1, function _() {
        return t.indexOf(a[a.length - 1]);
      }));
      return _objectSpread(_objectSpread({}, n), {}, {
        selectedIndex: d === -1 ? e.selectedIndex : d
      });
    }
    var u = t.slice(0, r.index),
      x = [].concat(_toConsumableArray(t.slice(r.index)), _toConsumableArray(u)).find(function (T) {
        return a.includes(T);
      });
    if (!x) return n;
    var f = (c = t.indexOf(x)) != null ? c : e.selectedIndex;
    return f === -1 && (f = e.selectedIndex), _objectSpread(_objectSpread({}, n), {}, {
      selectedIndex: f
    });
  }), 1, function _(e, r) {
    if (e.tabs.includes(r.tab)) return e;
    var t = e.tabs[e.selectedIndex],
      o = H([].concat(_toConsumableArray(e.tabs), [r.tab]), function (n) {
        return n.current;
      }),
      a = e.selectedIndex;
    return e.info.current.isControlled || (a = o.indexOf(t), a === -1 && (a = e.selectedIndex)), _objectSpread(_objectSpread({}, e), {}, {
      tabs: o,
      selectedIndex: a
    });
  }), 2, function _(e, r) {
    return _objectSpread(_objectSpread({}, e), {}, {
      tabs: e.tabs.filter(function (t) {
        return t !== r.tab;
      })
    });
  }), 3, function _(e, r) {
    return e.panels.includes(r.panel) ? e : _objectSpread(_objectSpread({}, e), {}, {
      panels: H([].concat(_toConsumableArray(e.panels), [r.panel]), function (t) {
        return t.current;
      })
    });
  }), 4, function _(e, r) {
    return _objectSpread(_objectSpread({}, e), {}, {
      panels: e.panels.filter(function (t) {
        return t !== r.panel;
      })
    });
  }),
  z = re(null);
z.displayName = "TabsDataContext";
function C(e) {
  var r = ne(z);
  if (r === null) {
    var t = new Error("<".concat(e, " /> is missing a parent <Tab.Group /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, C), t;
  }
  return r;
}
var V = re(null);
V.displayName = "TabsActionsContext";
function Q(e) {
  var r = ne(V);
  if (r === null) {
    var t = new Error("<".concat(e, " /> is missing a parent <Tab.Group /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(t, Q), t;
  }
  return r;
}
function _e(e, r) {
  return w(r.type, Le, e, r);
}
var De = "div";
function Se(e, r) {
  var _e$defaultIndex = e.defaultIndex,
    t = _e$defaultIndex === void 0 ? 0 : _e$defaultIndex,
    _e$vertical = e.vertical,
    o = _e$vertical === void 0 ? !1 : _e$vertical,
    _e$manual = e.manual,
    a = _e$manual === void 0 ? !1 : _e$manual,
    n = e.onChange,
    _e$selectedIndex = e.selectedIndex,
    u = _e$selectedIndex === void 0 ? null : _e$selectedIndex,
    _ = _objectWithoutProperties(e, _excluded);
  var x = o ? "vertical" : "horizontal",
    f = a ? "manual" : "auto";
  var c = u !== null,
    T = j({
      isControlled: c
    }),
    d = U(r),
    _ce = ce(_e, {
      info: T,
      selectedIndex: u != null ? u : t,
      tabs: [],
      panels: []
    }),
    _ce2 = _slicedToArray(_ce, 2),
    i = _ce2[0],
    s = _ce2[1],
    F = D(function () {
      return {
        selectedIndex: i.selectedIndex
      };
    }, [i.selectedIndex]),
    M = j(n || function () {}),
    b = j(i.tabs),
    m = D(function () {
      return _objectSpread({
        orientation: x,
        activation: f
      }, i);
    }, [x, f, i]),
    E = S(function (p) {
      return s({
        type: 1,
        tab: p
      }), function () {
        return s({
          type: 2,
          tab: p
        });
      };
    }),
    I = S(function (p) {
      return s({
        type: 3,
        panel: p
      }), function () {
        return s({
          type: 4,
          panel: p
        });
      };
    }),
    g = S(function (p) {
      R.current !== p && M.current(p), c || s({
        type: 0,
        index: p
      });
    }),
    R = j(c ? e.selectedIndex : i.selectedIndex),
    J = D(function () {
      return {
        registerTab: E,
        registerPanel: I,
        change: g
      };
    }, []);
  W(function () {
    s({
      type: 0,
      index: u != null ? u : t
    });
  }, [u]), W(function () {
    if (R.current === void 0 || i.tabs.length <= 0) return;
    var p = H(i.tabs, function (L) {
      return L.current;
    });
    p.some(function (L, B) {
      return i.tabs[B] !== L;
    }) && g(p.indexOf(i.tabs[R.current]));
  });
  var k = {
    ref: d
  };
  return G.createElement(ge, null, G.createElement(V.Provider, {
    value: J
  }, G.createElement(z.Provider, {
    value: m
  }, m.tabs.length <= 0 && G.createElement(me, {
    onFocus: function onFocus() {
      var p, h;
      var _iterator = _createForOfIteratorHelper(b.current),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var L = _step.value;
          if (((p = L.current) == null ? void 0 : p.tabIndex) === 0) return (h = L.current) == null || h.focus(), !0;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return !1;
    }
  }), N({
    ourProps: k,
    theirProps: _,
    slot: F,
    defaultTag: De,
    name: "Tabs"
  }))));
}
var Fe = "div";
function Ie(e, r) {
  var _C = C("Tab.List"),
    t = _C.orientation,
    o = _C.selectedIndex,
    a = U(r),
    n = D(function () {
      return {
        selectedIndex: o
      };
    }, [o]);
  return N({
    ourProps: {
      ref: a,
      role: "tablist",
      "aria-orientation": t
    },
    theirProps: e,
    slot: n,
    defaultTag: Fe,
    name: "Tabs.List"
  });
}
var he = "button";
function ve(e, r) {
  var Y, Z;
  var t = ae(),
    _e$id = e.id,
    o = _e$id === void 0 ? "headlessui-tabs-tab-".concat(t) : _e$id,
    _e$disabled = e.disabled,
    a = _e$disabled === void 0 ? !1 : _e$disabled,
    _e$autoFocus = e.autoFocus,
    n = _e$autoFocus === void 0 ? !1 : _e$autoFocus,
    u = _objectWithoutProperties(e, _excluded2),
    _C2 = C("Tab"),
    _ = _C2.orientation,
    x = _C2.activation,
    f = _C2.selectedIndex,
    c = _C2.tabs,
    T = _C2.panels,
    d = Q("Tab"),
    i = C("Tab"),
    s = q(null),
    F = U(s, r);
  W(function () {
    return d.registerTab(s);
  }, [d, s]);
  var M = se("tabs"),
    b = c.indexOf(s);
  b === -1 && (b = M);
  var m = b === f,
    E = S(function (l) {
      var X;
      var A = l();
      if (A === K.Success && x === "auto") {
        var $ = (X = xe(s)) == null ? void 0 : X.activeElement,
          ee = i.tabs.findIndex(function (Te) {
            return Te.current === $;
          });
        ee !== -1 && d.change(ee);
      }
      return A;
    }),
    I = S(function (l) {
      var A = c.map(function ($) {
        return $.current;
      }).filter(Boolean);
      if (l.key === y.Space || l.key === y.Enter) {
        l.preventDefault(), l.stopPropagation(), d.change(b);
        return;
      }
      switch (l.key) {
        case y.Home:
        case y.PageUp:
          return l.preventDefault(), l.stopPropagation(), E(function () {
            return v(A, P.First);
          });
        case y.End:
        case y.PageDown:
          return l.preventDefault(), l.stopPropagation(), E(function () {
            return v(A, P.Last);
          });
      }
      if (E(function () {
        return w(_, {
          vertical: function vertical() {
            return l.key === y.ArrowUp ? v(A, P.Previous | P.WrapAround) : l.key === y.ArrowDown ? v(A, P.Next | P.WrapAround) : K.Error;
          },
          horizontal: function horizontal() {
            return l.key === y.ArrowLeft ? v(A, P.Previous | P.WrapAround) : l.key === y.ArrowRight ? v(A, P.Next | P.WrapAround) : K.Error;
          }
        });
      }) === K.Success) return l.preventDefault();
    }),
    g = q(!1),
    R = S(function () {
      var l;
      g.current || (g.current = !0, (l = s.current) == null || l.focus({
        preventScroll: !0
      }), d.change(b), ye(function () {
        g.current = !1;
      }));
    }),
    J = S(function (l) {
      l.preventDefault();
    }),
    _te = te({
      autoFocus: n
    }),
    k = _te.isFocusVisible,
    p = _te.focusProps,
    _de = de({
      isDisabled: a
    }),
    h = _de.isHovered,
    L = _de.hoverProps,
    _fe = fe({
      disabled: a
    }),
    B = _fe.pressed,
    ie = _fe.pressProps,
    pe = D(function () {
      return {
        selected: m,
        hover: h,
        active: B,
        focus: k,
        autofocus: n,
        disabled: a
      };
    }, [m, h, k, B, n, a]),
    ue = le({
      ref: F,
      onKeyDown: I,
      onMouseDown: J,
      onClick: R,
      id: o,
      role: "tab",
      type: be(e, s),
      "aria-controls": (Z = (Y = T[b]) == null ? void 0 : Y.current) == null ? void 0 : Z.id,
      "aria-selected": m,
      tabIndex: m ? 0 : -1,
      disabled: a || void 0,
      autoFocus: n
    }, p, L, ie);
  return N({
    ourProps: ue,
    theirProps: u,
    slot: pe,
    defaultTag: he,
    name: "Tabs.Tab"
  });
}
var Ce = "div";
function Me(e, r) {
  var _C3 = C("Tab.Panels"),
    t = _C3.selectedIndex,
    o = U(r),
    a = D(function () {
      return {
        selectedIndex: t
      };
    }, [t]);
  return N({
    ourProps: {
      ref: o
    },
    theirProps: e,
    slot: a,
    defaultTag: Ce,
    name: "Tabs.Panels"
  });
}
var Ge = "div",
  Ue = oe.RenderStrategy | oe.Static;
function He(e, r) {
  var E, I, g, R;
  var t = ae(),
    _e$id2 = e.id,
    o = _e$id2 === void 0 ? "headlessui-tabs-panel-".concat(t) : _e$id2,
    _e$tabIndex = e.tabIndex,
    a = _e$tabIndex === void 0 ? 0 : _e$tabIndex,
    n = _objectWithoutProperties(e, _excluded3),
    _C4 = C("Tab.Panel"),
    u = _C4.selectedIndex,
    _ = _C4.tabs,
    x = _C4.panels,
    f = Q("Tab.Panel"),
    c = q(null),
    T = U(c, r);
  W(function () {
    return f.registerPanel(c);
  }, [f, c]);
  var d = se("panels"),
    i = x.indexOf(c);
  i === -1 && (i = d);
  var s = i === u,
    _te2 = te(),
    F = _te2.isFocusVisible,
    M = _te2.focusProps,
    b = D(function () {
      return {
        selected: s,
        focus: F
      };
    }, [s, F]),
    m = le({
      ref: T,
      id: o,
      role: "tabpanel",
      "aria-labelledby": (I = (E = _[i]) == null ? void 0 : E.current) == null ? void 0 : I.id,
      tabIndex: s ? a : -1
    }, M);
  return !s && ((g = n.unmount) == null || g) && !((R = n.static) != null && R) ? G.createElement(Pe, _objectSpread({
    "aria-hidden": "true"
  }, m)) : N({
    ourProps: m,
    theirProps: n,
    slot: b,
    defaultTag: Ge,
    features: Ue,
    visible: s,
    name: "Tabs.Panel"
  });
}
var we = O(ve),
  Oe = O(Se),
  Ne = O(Ie),
  ke = O(Me),
  Be = O(He),
  st = Object.assign(we, {
    Group: Oe,
    List: Ne,
    Panels: ke,
    Panel: Be
  });
export { st as Tab, Oe as TabGroup, Ne as TabList, Be as TabPanel, ke as TabPanels };